// extracted by mini-css-extract-plugin
module.exports = {"manualAction":"CarStatus_manualAction__MFy87","icon":"CarStatus_icon__3RQnC","adminStatus":"CarStatus_adminStatus__3cFq0","statusLabel":"CarStatus_statusLabel__2beJr"};